import { motion } from 'framer-motion'
import { Hourglass, UserX, LogOut } from 'lucide-react'
import { useAuth } from '../../context/AuthContext'
import { Button } from '../../components/common'

const copy = {
  pending: {
    icon: Hourglass,
    iconClass: 'bg-amber-100 text-amber-600',
    title: 'Awaiting Approval',
    body: "Thanks for registering! An administrator will review your account and assign your departments. You'll have access as soon as you're approved — check back shortly.",
  },
  inactive: {
    icon: UserX,
    iconClass: 'bg-gray-200 text-gray-500',
    title: 'Account Inactive',
    body: 'Your portal access is currently inactive. If you believe this is a mistake, please contact the church office at info@dlbcclarksville.org.',
  },
}

const AwaitingApproval = ({ variant = 'pending' }) => {
  const { signOut, userProfile } = useAuth()
  const { icon: Icon, iconClass, title, body } = copy[variant] || copy.pending

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-900 via-dark to-secondary-900 flex items-center justify-center p-4">
      <motion.div
        className="relative w-full max-w-md"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
          <div className={`w-16 h-16 ${iconClass} rounded-full flex items-center justify-center mx-auto mb-4`}>
            <Icon className="w-8 h-8" />
          </div>
          <h1 className="text-2xl font-heading font-bold text-dark-100 mb-2">{title}</h1>
          {userProfile?.displayName && (
            <p className="text-gray-500 mb-1">Hi {userProfile.displayName},</p>
          )}
          <p className="text-gray-600 mb-8">{body}</p>
          <Button variant="outline" icon={LogOut} onClick={signOut}>
            Sign Out
          </Button>
        </div>
      </motion.div>
    </div>
  )
}

export default AwaitingApproval
